
import React from 'react';
import { 
  Card, 
  CardContent, 
} from "@/components/ui/card";
import { CountryDropdown } from '@/components/team-details/dropdowns/CountryDropdown';
import { LeagueDropdown } from '@/components/team-details/dropdowns/LeagueDropdown';
import { TeamsDropdown } from '@/components/team-details/dropdowns/TeamsDropdown';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

interface OddsFilterProps {
  countries: string[];
  leagues: string[];
  years: string[];
  teams: string[];
  selectedCountry: string | null;
  selectedLeague: string | null;
  selectedYears: string[];
  selectedTeam: string | null;
  onCountrySelect: (country: string) => void;
  onLeagueSelect: (league: string) => void;
  onYearSelect: (year: string) => void;
  onYearToggle: (year: string) => void;
  onClearYears: () => void;
  onTeamSelect: (team: string) => void;
}

export const OddsFilter: React.FC<OddsFilterProps> = ({
  countries,
  leagues,
  years,
  teams,
  selectedCountry,
  selectedLeague,
  selectedYears,
  selectedTeam,
  onCountrySelect,
  onLeagueSelect,
  onYearSelect,
  onYearToggle,
  onClearYears,
  onTeamSelect,
}) => {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold mb-4">Filter Options</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Country
          </label>
          <CountryDropdown
            countries={countries}
            selectedCountry={selectedCountry}
            onCountrySelect={onCountrySelect}
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            League
          </label>
          <LeagueDropdown
            leagues={leagues}
            selectedLeague={selectedLeague}
            onLeagueSelect={onLeagueSelect}
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Team (Optional)
          </label>
          <TeamsDropdown
            teams={teams}
            currentTeam={selectedTeam}
            onTeamSelect={onTeamSelect}
          />
        </div>
        
        <div>
          <div className="flex justify-between items-center mb-1">
            <label className="block text-sm font-medium text-gray-700">
              Seasons
            </label>
            {selectedYears.length > 0 && (
              <Button 
                variant="ghost" 
                size="sm" 
                className="text-red-500 hover:text-red-700 h-6 py-0 px-2"
                onClick={onClearYears}
              >
                Clear
              </Button>
            )}
          </div>
          <div className="flex flex-wrap gap-2">
            {years.map((year) => (
              <Button
                key={year}
                variant={selectedYears.includes(year) ? "default" : "outline"}
                size="sm"
                onClick={() => onYearToggle(year)}
              >
                {year}
                {selectedYears.includes(year) && (
                  <Badge variant="secondary" className="ml-1 text-xs">✓</Badge>
                )}
              </Button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
